import { getLokiBootstrapperConfig } from './../getLokiBootstrapperConfig';
import { fetchLokiConfigAsync as fetchLokiConfig } from '@msfast/lpc-bootstrapper';
import { LokiConfig } from './../models/models';

let lokiConfig = undefined;

export function fetchLokiConfigAsync(): Promise<LokiConfig> {
    if (lokiConfig) {
        return Promise.resolve(lokiConfig);
    }

    const bootstrapperConfig = getLokiBootstrapperConfig();

    return fetchLokiConfig(bootstrapperConfig).then(config => {
        lokiConfig = config;
        return lokiConfig;
    });
}
